// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H12V8.68241C12.4561 9.36872 12.7749 10.1548 12.9169 11H14V7H22V17H14V13H12.9169C12.7749 13.8452 12.4561 14.6313 12 15.3176V22H2V15.3176C1.36833 14.3671 1 13.2254 1 12C1 10.7746 1.36833 9.63288 2 8.68241V2ZM7 8C5.69217 8 4.53097 8.6266 3.79949 9.60019C3.29723 10.2687 3 11.0982 3 12C3 12.9018 3.29723 13.7313 3.79949 14.3998C4.53097 15.3734 5.69217 16 7 16C8.30784 16 9.46903 15.3734 10.2005 14.3998C10.7028 13.7313 11 12.9018 11 12C11 11.0982 10.7028 10.2687 10.2005 9.60019C9.46903 8.6266 8.30784 8 7 8Z"}}]};

const DvFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dv-filled',
    ref,
    icon: element,
  },
));

DvFilledIcon.displayName = 'DvFilledIcon';

export default DvFilledIcon;
